module.exports = __webpack_public_path__ + "img/back.c7348a7d.png";